// Croqui: `components/Pill.tsx`.
//
// WEB-133: é o `Badge` de `components/ui` com `dot`. Desde 17/10/2026 o estado pinta texto,
// quadrado e um tom chapado de fundo (ver `badge.tsx`). Mesmo selo das telas do lojista.

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';
import { Badge } from '../ui/badge.tsx';
import type { Tone } from './ink.ts';

const VARIANT = {
  ok: 'success',
  wait: 'warning',
  bad: 'destructive',
  neutral: 'secondary',
  info: 'secondary',
  attention: 'attention',
} as const satisfies Record<Tone, string>;

/** Status: pílula neutra com o quadrado de cor do tom. */
export function Pill({
  tone,
  children,
  className,
}: {
  tone: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Badge
      variant={VARIANT[tone]}
      dot
      // `info` é o tom "em tinta": quadrado na cor do texto, não no cinza do neutro.
      className={cn(tone === 'info' && '[--dot:var(--foreground)]', className)}
    >
      {children}
    </Badge>
  );
}

export type { Tone as PillTone };
